import React from 'react';
import { Typography, Switch } from 'antd';

const { Text } = Typography;

interface SwitchFieldProps {
  field: any;
  value: boolean | string | undefined;
  onChange: (v: boolean | string) => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const valueType = field.valueType || 'boolean'; // default: boolean

  // Normalizar el valor a boolean para el Switch
  const normalizeToBoolean = (val: any): boolean => {
    if (typeof val === 'boolean') return val;
    if (val === 'si' || val === 'true') return true;
    if (val === 'no' || val === 'false') return false;
    return !!field.defaultValue;
  };

  // Convertir boolean a string si es necesario
  const normalizeOutput = (boolValue: boolean): boolean | string => {
    if (valueType === 'string') {
      return boolValue ? 'si' : 'no';
    }
    return boolValue;
  };

  const checked = normalizeToBoolean(value);

  const handleChange = (newChecked: boolean) => {
    onChange(normalizeOutput(newChecked));
  };

  return (
    <div
      style={{
        ...commonStyle,
        flexDirection: 'row',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase', margin: 0 }}>
        {field.label}
      </Text>
      <Switch
        checked={checked}
        onChange={handleChange}
        style={{
          zIndex: 10,
          background: checked ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : undefined
        }}
      />
      {error && (
        <Text type='danger' style={{ fontSize: 12, marginLeft: '8px' }}>
          {error}
        </Text>
      )}
    </div>
  );
};
